import { ShortCrypt } from "short-crypt";
import { localdb, localUsers } from "./localDbUtil";

const shortCryptKey = "JwOwwUuFqcA9vEuZiBdT0w==";
const shortCrypt = new ShortCrypt(shortCryptKey);

const ENV_PROD = "PROD";
const ENV_DEV = "DEV";

export const getEnv = () => {
    if (process.env.NODE_ENV === "development") {
        return ENV_DEV;
    }
    return ENV_PROD;
}
export const TOKEN_HEADER_KEY = "qz-auth-token";

export const getAuthToken = () => {
    let activeUser = localUsers.getActiveUser();
    if (activeUser) {
        return activeUser.authToken;
    }
    return null;
    //return localdb.get(TOKEN_HEADER_KEY);
}

export const encrypt = (plainText) => {
    let cipher = shortCrypt.encryptToURLComponent(plainText.toString());
    return cipher;
}
export const decrypt = (cipher) => {
    let decrypted = shortCrypt.decryptURLComponent(cipher);
    if (decrypted) {
        return new TextDecoder().decode(decrypted.buffer);
    }
    return null;
}

export const authUtil = {
    getLink: (links, linkName) => {
        if (!links || !Array.isArray(links) || !linkName) {
            return null;
        }
        let link = links.filter((link) => link.name == linkName)[0];
        return link;
    },
    hasLink: (links, linkName) => {
        if (!links || !Array.isArray(links) || !linkName) {
            return false;
        }
        let resLinks = links.filter((link) => link.name == linkName)
        return resLinks.length > 0;
    }
}

export const enterFullScreen = (elementId) => {
    const element = document.getElementById(elementId);
    if (!element) {
        return;
    }
    const isFullScreen = document.fullscreenElement;
    if (isFullScreen) {
        closeFullscreen();
    } else {
        openFullscreen(element);
    }
}

const openFullscreen = (elem) => {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
    }
}

const closeFullscreen = () => {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
    }
}

export const formatSecondsToHHMMSS = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let formattedHours = String(hours).padStart(2, '0');
    let formattedMinutes = String(minutes).padStart(2, '0');
    let formattedSeconds = String(seconds).padStart(2, '0');
    let result = "";
    if (hours && hours > 0) {
        result = formattedHours + ":";
    }
    return result + formattedMinutes + ":" + formattedSeconds;
}

export const getBaseUri = () => {
    let env = getEnv();
    let uri = window.location.hostname;
    if (env === "DEV") {
        uri = "http://" + uri + "/quiz"
    } else {
        uri = "https://" + uri;
    }
    return uri;
}

export const getUIBaseUri = () => {
    let env = getEnv();
    let uri = window.location.hostname;
    if (env === "DEV") {
        uri = "http://" + uri +":"+window.location.port;
    } else {
        uri = "https://" + uri;
    }
    return uri;
}


const MEDIA_API_V1 = "/media/v1";
export const getMediaUri = () => {
    return getBaseUri() + MEDIA_API_V1;
}

export const AvatarUtil = {
     avatarColors : [
        "#941CE9",
        "#BB6DC6",
        "#01D6FF",
        "#74D680",
        "#058D79",
        "#48B8A5",
        "#00089C",
        "#74B3CE",
        "#058D79",
        "#A97990",
        "#FFD600",
        "#D7AD00",
        "#96DEFE",
        "#FF0038",
        "#0BA575",
        "#FF3D88",
        "#406D96",
        "#06C1BB",
        "#FF5E79",
    ],
    getAvatarColor: () => {
        const randomIndex = Math.floor(Math.random() * AvatarUtil.avatarColors.length);
        return AvatarUtil.avatarColors[randomIndex];
    }
}

export const paginationUtil = {
    getParams: (paginatorConfig) => {
        if (!paginatorConfig || !paginatorConfig.pageNumber || !paginatorConfig.pageSize) {
            return "?limit=5&offset=0";
        }
        const offset = (paginatorConfig.pageNumber - 1) * paginatorConfig.pageSize;
        let queryStr = "?limit=" + paginatorConfig.pageSize + "&offset=" + offset;
        return queryStr;
    },
    getConfig: (config) => {
        if (!config) {
            return { pageNumber: 1, pageSize: 5 };
        }
        return config;
    }
}
